import type { DrillDownParams, ReportFilters } from './resources'

const adminQueries = {
  adminAddresses: () => ['admin/addresses'],
  adminTelePoliciesList: () => ['admin/tele-policies/list'],
  adminTelePolicyTemplatesList: () => ['admin/tele-policy-templates/list'],
  adminTextTemplates: () => ['admin/text-templates'],
  adminTextTemplateDetails: (id: number) => ['admin/text-templates', id],
  adminWhiteLabels: () => ['admin/whitelabels'],
  adminTextTemplateCodes: () => ['admin/text-templates-codes'],
  adminCostObjectList: () => ['admin/cost-object/list'],
  adminEmployeeList: () => ['admin/employees/list'],
  adminCostObjectDetails: (id: number) => ['admin/cost-object', id],
  adminAssetList: () => ['admin/asset/list'],
  adminLeasedAssetList: () => ['admin/asset/list/leased'],
  adminAsset: (id: number) => ['admin/asset', id],
  adminCustomers: () => ['admin/customers'],
  adminAssetTypes: () => ['admin/asset-types'],
  adminDrillDownCustomerTotals: (params: DrillDownParams) => [
    'admin/customer-totals',
    params.year,
    params.period,
  ],
  adminDrillDownCategories: (params: DrillDownParams) => [
    'admin/categories',
    params.year,
    params.period,
    params.type,
    params.typeId,
  ],
  adminDrillDownGroups: (params: DrillDownParams) => [
    'admin/groups',
    params.year,
    params.period,
    params.type,
    params.typeId,
    params.productCategoryId,
  ],
  adminDrillDownProducts: (params: DrillDownParams) => [
    'admin/products',
    params.year,
    params.period,
    params.type,
    params.typeId,
    params.productCategoryId,
    params.productGroupId,
  ],
  adminDrillDownCostObjects: (params: DrillDownParams) => [
    'admin/drill-down/cost-objects',
    params.year,
    params.period,
    params.type,
    params.typeId,
    params.productCategoryId,
    params.productGroupId,
    params.productId,
  ],
  adminDrillDownDepartments: (params: DrillDownParams) => [
    'admin/drill-down/departments',
    params.year,
    params.period,
    params.type,
    params.typeId,
  ],
  adminDrillDownDepartmentsCostObjects: (params: DrillDownParams) => [
    'admin/drill-down/departments/cost-objects',
    params.year,
    params.period,
    params.type,
    params.typeId,
    params.departmentId,
  ],
  adminDrillDownDepartmentsCostObjectsProducts: (params: DrillDownParams) => [
    'admin/drill-down/departments/cost-objects/products',
    params.year,
    params.period,
    params.type,
    params.typeId,
    params.departmentId,
    params.costObjectId,
  ],
  adminDrillDownCostObject: (params: DrillDownParams) => [
    'admin/drill-down/cost-object',
    params.year,
    params.period,
    params.type,
    params.typeId,
  ],

  adminDrillDownCostObjectProducts: (params: DrillDownParams) => [
    'admin/drill-down/cost-object/products',
    params.year,
    params.period,
    params.type,
    params.typeId,
    params.costObjectId,
  ],
  adminConsents: () => ['admin/consents'],
  adminConsentDetails: (id: number) => ['admin/consents', id],
  adminConsentReports: (consentId: number, costObjectId: number) => [
    'admin/consents',
    consentId,
    'reports',
    costObjectId,
  ],
  adminDepartmentsList: () => ['admin/departments/list'],
  adminDepartmentsDetails: (id: number) => ['admin/departments', id],
  adminSMSLogsList: () => ['admin/sms-logs/list'],
  adminSMSLogsListByBatch: (batchId: string) => ['admin/sms-logs/list/batch', batchId],
  adminPhoneBooksList: () => ['admin/phone/books/list'],
  adminActiveNumbersList: () => ['admin/phone/numbers/list'],
  adminUserAliasesList: () => ['admin/phone/user-aliases/list'],
  adminGroupNumbersList: () => ['admin/phone/group-numbers/list'],
  adminGroupsList: () => ['admin/phone/groups/list'],
  adminInvoicesList: () => ['admin/invoices/list'],
  adminVendorInvoicesList: () => ['admin/vendor-invoices/list'],
  adminInvoicesDetails: (id: number) => ['admin/invoices', id],
  adminUsersList: () => ['admin/users/list'],
  adminUserCustomersList: () => ['admin/users/customers'],
  adminUserDetails: (id: number) => ['admin/users', id],
  adminSetupExportSettings: () => ['admin/reports/setup-export-settings'],
  adminAccountingReports: (filters: ReportFilters) => ['admin/reports/accounting-reports', filters],
  adminCustomerSpecificReports: () => ['admin/reports/customer-specific'],
  adminReportCustomers: () => ['admin/reports/customers'],
  adminSalaryDeductionUsageReports: (filters: ReportFilters) => [
    'admin/reports/salary-deduction-usage-reports',
    filters,
  ],
  adminSalaryDeductionDeviceReports: (filters: ReportFilters) => [
    'admin/reports/salary-deduction-device-reports',
    filters,
  ],
  adminConsumptionReports: (filters: ReportFilters) => [
    'admin/reports/consumption-reports',
    filters,
  ],
  adminOffboardingReports: (filters: ReportFilters) => [
    'admin/reports/offboarding-reports',
    filters,
  ],
  adminTaxAdvantageReports: (filters: ReportFilters) => [
    'admin/reports/tax-advantage-reports',
    filters,
  ],
  adminNewNumberOrdersReports: (filters: ReportFilters) => [
    'admin/reports/new-number-orders-reports',
    filters,
  ],
  adminTradeIdOrdersList: (customerId: number) => ['admin/trade-in/orders/list', customerId],
  adminAssetTradeInOrderStatus: (assetId: number) => ['admin/asset/trade-in/order-status', assetId],
  adminAssetTradeInOrder: (assetGuid: string) => ['admin/asset/trade-in/order', assetGuid],
  adminTradeInCustomerAgreements: (customerId: number) => [
    'admin/trade-in/customer-agreements',
    customerId,
  ],
  adminFeatures: () => ['admin/features'],
  adminFeatureDetails: (id: number) => ['admin/features', id],
  adminFeatureActivities: (id: number) => ['admin/features/activities', id],
  adminFeatureSalesPitch: (id: number) => ['admin/features', id, 'sales-pitch'],
  adminFeatureTermsOfService: (id: number) => ['admin/features', id, 'terms-of-service'],
  adminLeasingAssetDetails: (id: number) => ['admin/leasing/asset', id, 'details'],
}

export default adminQueries
